module.exports = __webpack_public_path__ + "img/q29.aff60bd9.png";